// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_h7-0";
export var buttonContainer = "_h7-3";
export var cancelButton = "_h7-4";
export var headerSection = "_h7-6";
export var headerTitle = "_h7-9";
export var messageSideLeft = "_h7-1";
export var messageSideRight = "_h7-2";
export var orderNumberContainer = "_h7-7";
export var orderNumberLabel = "_h7-8";
export var submitButton = "_h7-5";